import { createFileRoute } from '@tanstack/react-router';

import { RouterContext } from '~/types/router.type';

import { ContractDetails } from '~/modules/contract/single';

import { i18n } from '~/utils';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { getContract } from '../../-routeParams';
import { routeParams } from '../../../-routeParams';

const title = i18n.t(($) => $.pageTitle, {
  contractNumber: '',
  ns: 'contract',
});

export const Route = createFileRoute(
  '/(main)/demand/contracts/$contractId/items/$itemId/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/contracts/$contractId/items/$itemId/',
    ...routeParams,
  }),
  component: ContractDetails,
  head: ({ loaderData }: { loaderData?: RouterContext }) =>
    getRouteHead(
      `${title} ${loaderData?.pageData?.title ?? ''}`,
      'Verwalte deinen Vertrag in VESTIGAS',
    ),
  loader: ({ context, params }) => getContract({ context, params }),
  staticData: {
    AppBar: {
      title,
    },
  },
});
